export default __webpack_public_path__ + "static/media/Pak-army.b940f3b5.png";